(() => {
  const selector = '[data-cbh-lab-directory]';

  function initialise(root) {
    if (!root || root.dataset.cbhLabDirectoryReady === 'true') return;

    const cards = Array.from(root.querySelectorAll('[data-cbh-lab-report]'));
    const search = root.querySelector('[data-cbh-lab-search]');
    const brandSelect = root.querySelector('[data-cbh-lab-brand]');
    const formatSelect = root.querySelector('[data-cbh-lab-format]');
    const count = root.querySelector('[data-cbh-lab-count]');
    const empty = root.querySelector('[data-cbh-lab-empty]');
    const clear = root.querySelector('[data-cbh-lab-clear]');
    const moreWrap = root.querySelector('[data-cbh-lab-more-wrap]');
    const more = root.querySelector('[data-cbh-lab-more]');
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const desktopInitialResults = Math.max(1, Number.parseInt(root.dataset.initialResults || '12', 10));
    const desktopResultsIncrement = Math.max(1, Number.parseInt(root.dataset.resultsIncrement || '12', 10));
    const mobileInitialResults = Math.max(1, Number.parseInt(root.dataset.mobileInitialResults || '6', 10));
    const mobileResultsIncrement = Math.max(1, Number.parseInt(root.dataset.mobileResultsIncrement || '6', 10));
    const getInitialResults = () => mobileQuery.matches ? mobileInitialResults : desktopInitialResults;
    const getResultsIncrement = () => mobileQuery.matches ? mobileResultsIncrement : desktopResultsIncrement;
    let visibleLimit = getInitialResults();

    root.dataset.cbhLabDirectoryReady = 'true';
    root.classList.add('is-enhanced');

    function hideUnusedOptions(select, datasetKey) {
      if (!select) return;
      Array.from(select.options).forEach((option) => {
        if (option.value === 'all') return;
        option.hidden = !cards.some((card) => card.dataset[datasetKey] === option.value);
      });
    }

    hideUnusedOptions(brandSelect, 'vendor');
    hideUnusedOptions(formatSelect, 'format');

    function update() {
      const query = (search?.value || '').trim().toLocaleLowerCase();
      const activeBrand = brandSelect?.value || 'all';
      const activeFormat = formatSelect?.value || 'all';
      let matched = 0;
      let visible = 0;

      cards.forEach((card) => {
        const brandMatches = activeBrand === 'all' || card.dataset.vendor === activeBrand;
        const formatMatches = activeFormat === 'all' || card.dataset.format === activeFormat;
        const searchMatches = !query || (card.dataset.search || '').includes(query);
        const matches = brandMatches && formatMatches && searchMatches;

        if (matches) {
          matched += 1;
          const shouldShow = matched <= visibleLimit;
          card.hidden = !shouldShow;
          if (shouldShow) visible += 1;
        } else {
          card.hidden = true;
        }
      });

      if (count) {
        count.textContent = matched === visible
          ? `${matched} product report${matched === 1 ? '' : 's'} available`
          : `Showing ${visible} of ${matched} product reports`;
      }
      if (empty) empty.hidden = matched !== 0;
      if (moreWrap) moreWrap.hidden = matched === 0 || visible >= matched;
    }

    function resetVisibleLimitAndUpdate() {
      visibleLimit = getInitialResults();
      update();
    }

    search?.addEventListener('input', resetVisibleLimitAndUpdate);
    brandSelect?.addEventListener('change', resetVisibleLimitAndUpdate);
    formatSelect?.addEventListener('change', resetVisibleLimitAndUpdate);

    search?.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !search.value) return;
      search.value = '';
      resetVisibleLimitAndUpdate();
    });

    clear?.addEventListener('click', () => {
      if (search) search.value = '';
      if (brandSelect) brandSelect.value = 'all';
      if (formatSelect) formatSelect.value = 'all';
      visibleLimit = getInitialResults();
      update();
      search?.focus();
    });

    more?.addEventListener('click', () => {
      const previouslyVisible = cards.filter((card) => !card.hidden).length;
      visibleLimit += getResultsIncrement();
      update();
      const visibleCards = cards.filter((card) => !card.hidden);
      visibleCards[previouslyVisible]?.querySelector('a:not([tabindex="-1"])')?.focus();
    });

    const handleBreakpointChange = () => {
      visibleLimit = getInitialResults();
      update();
    };

    const removeBreakpointListener = () => {
      if (typeof mobileQuery.removeEventListener === 'function') {
        mobileQuery.removeEventListener('change', handleBreakpointChange);
      } else if (typeof mobileQuery.removeListener === 'function') {
        mobileQuery.removeListener(handleBreakpointChange);
      }
    };

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', handleBreakpointChange);
    } else {
      mobileQuery.addListener(handleBreakpointChange);
    }

    root.cbhLabDirectoryCleanup = removeBreakpointListener;
    update();
  }

  function boot(scope = document) {
    if (scope.matches?.(selector)) initialise(scope);
    scope.querySelectorAll?.(selector).forEach(initialise);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches?.(selector) ? event.target : event.target.querySelector?.(selector);
    root?.cbhLabDirectoryCleanup?.();
  });
})();
